module.exports = __webpack_public_path__ + "img/3.d12ce7e1.jpg";